import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

/**
 * Endpoints do cliente para o swap mesa-cliente (Task 15 do Higher-API):
 * `/v1/baas/swap/quotes`, `/v1/baas/swap/quotes/{id}/accept`,
 * `/v1/baas/swap/operations` e `/v1/baas/swap/operations/{id}`.
 *
 * O e-mail vai em todo payload/query porque o backend deriva a empresa do
 * cliente autenticado a partir dele — nunca aceita um documento/CNPJ
 * declarado pelo chamador (correção de vazamento entre clientes da Task 15).
 *
 * `SetupBackend` já injeta `X-BaaS-Authorization` sozinho (interceptador em
 * `services/config/config.js`), então nenhuma chamada aqui monta cabeçalho
 * de autenticação.
 */

function createQuote(payload) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/baas/swap/quotes", payload);
}

function acceptQuote(id, payload) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(`/v1/baas/swap/quotes/${id}/accept`, payload);
}

function listOperations(email, limit = 20) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get("/v1/baas/swap/operations", {
    params: { email, limit },
  });
}

function getOperation(id, email) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(`/v1/baas/swap/operations/${id}`, {
    params: { email },
  });
}

const SwapService = {
  createQuote,
  acceptQuote,
  listOperations,
  getOperation,
};

export default SwapService;
